import { useTheme } from '@bcp-nextgen-dx-component-factory/design-system';
import { useGetTextForAnimation } from '@hooks';
import { LoaderTextAnimation } from '@types';

interface ListTextAnimationHelperOutput {
	listTextAnimation: LoaderTextAnimation[];
	paletteUi9: string;
	hasText: boolean;
}

export const useListTextAnimationHelper = (): ListTextAnimationHelperOutput => {
	const { colorPalette } = useTheme();
	const listTextAnimation = useGetTextForAnimation();

	const paletteUi9 = colorPalette.color_01[400];
	const hasText = listTextAnimation.length > 0;

	return { listTextAnimation, paletteUi9, hasText };
};
